
import moment from 'moment'
import React, { Component } from 'react'
import Messengers from '../../Messengers'

export default class ProfileAppointedAuction extends Component {

  render() {

    const { data, back } = this.props

    return (
        <div className='ProfileContainer'>
            <div className='ProfileContainer__wrapper'>
                <div className='ProfileContainer__header'>
                    <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" onClick={back} alt="" />
                    <p className='ProfileContainer__header-left'>{moment(data.is.created).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY')}</p>
                    <p className='ProfileContainer__header-right'>встреча состоится {moment(data.date).fromNow()}</p>
                </div>
                <div className='ProfileContainer__main ProfileContainer__main_grid'>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Статус встречи</p>
                        <div  className='ProfileContainer__output-main'>
                        Назначена
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Меценат</p>
                        <div  className='ProfileContainer__output-main'>
                        {`${data.user.name} ${data.user.surname}`}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Дата</p>
                        <div  className='ProfileContainer__output-main'>
                        {moment(data.date).format("DD/MM/YYYY")}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Время</p>
                        <div  className='ProfileContainer__output-main'>
                        {moment(data.date).format("HH:mm")}
                        </div>
                    </div>
                    <div className='ProfileContainer__output ProfileContainer__output_row'>
                        <p className='ProfileContainer__output-top'>Место встречи</p>
                        <div  className='ProfileContainer__output-main'>
                        {data.placeName}
                        </div>
                    </div>
                </div>
            </div>
            <Messengers/>

        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileContainers/ProfileAppointedAuctionCard.jsx